import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { buildArubaClientJSON } from "../lib/arubaCliente";

export function CopiaDatiClienteButton({ data, testId = "copia-dati-cliente" }) {
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    const text = buildArubaClientJSON(data || {});
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand("copy"); } catch { /* noop */ }
      document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="inline-flex items-center gap-2">
      <button
        type="button"
        onClick={onCopy}
        data-testid={testId}
        title="Copia i dati del cliente nel formato del form Aruba"
        className="inline-flex items-center gap-1.5 h-8 px-3 rounded-md border border-slate-600 text-slate-200 text-xs font-semibold hover:bg-slate-800 transition-colors"
      >
        <Copy className="h-3.5 w-3.5" /> Copia dati cliente
      </button>
      {copied && (
        <span data-testid={`${testId}-copied`} className="inline-flex items-center gap-1 text-xs font-semibold text-emerald-500">
          <Check className="h-3.5 w-3.5" /> Copiato!
        </span>
      )}
    </div>
  );
}
